import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="dot dot-1"></div>
      <div className="dot dot-2"></div>
      <div className="dot dot-3"></div>
    </div>
  );
};

export default Spinner;
